import { render, staticRenderFns } from "./o-logo.vue?vue&type=template&id=aa09a7ea&"
import script from "./o-logo.vue?vue&type=script&lang=js&"
export * from "./o-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports